import React from 'react';
import { Row, Col } from "./../../ui/ot";
import HolidayOverview from '../../shift_management/holiday_overview'
import { useSearchParams } from 'react-router-dom';

const HolidayManagement = () => {
    const [searchParams] = useSearchParams()
    const { schedule_id } = Object.fromEntries([...searchParams])
    if (!/^[1-9][0-9]*$/.test(schedule_id || '') || Number(schedule_id) > 2147483647) {
        return <div role="alert">缺少有效的排程，請從館別開館設定重新進入年度假日設定。</div>
    }
    return (<Row>
        <Col span={24}>
            <HolidayOverview
                propsHolidaySettingNewYearApi='/reservation_registration_and_space_management/api/holiday/new_year'
                propsHolidaySettingApi="/reservation_registration_and_space_management/backend/holiday"
                propsSearchparams={{
                    schedule_id
                }}
                propsHolidaySettingNewYearParams={{
                    schedule_id: schedule_id
                }}
                propsHolidaySettingNewYearInitialvalue={{
                    holiday_holiday_setting_data: [
                        {
                            schedule_holiday_data: [
                                {
                                    schedule_id: schedule_id
                                }
                            ]
                        }
                    ]

                }}
            />
        </Col>
    </Row>)
}
export default HolidayManagement
